export default "__VITE_ASSET__CaDZiFH$__"